let section = document.querySelectorAll('section'),
    scroll = window.scrollY,
    navLink = document.querySelectorAll('.nav__link--main'),
    navLinkSub = document.querySelectorAll('.nav__list-item .nav__link'),
    windowWidth = window.innerWidth

window.addEventListener('scroll', () => {
    scroll = window.scrollY

    // Detect active section
    section.forEach((element) => {

        if ( scroll >= element.offsetTop && scroll <= element.offsetTop + element.offsetHeight) {
            element.classList.add('active-section')
        } else {
            element.classList.remove('active-section')
        }

    })

    // Active nav item
    let activeSection = document.querySelector('.active-section')

    if (activeSection !== null) {

        let activeSectionData = activeSection.getAttribute('data-section')

        navLink.forEach((element) => {

            let link = element.getAttribute('data-link')

            element.parentElement.classList.remove('nav__list-item--active')

            if (link === activeSectionData) {
                element.parentElement.classList.add('nav__list-item--active')
            }

        })

    }

})

navLink.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault()

        const elem = document.querySelector(this.getAttribute('href')).getBoundingClientRect().top + window.pageYOffset

        window.scrollTo({
            top: elem,
            behavior: 'smooth'
        })

    })
})

navLinkSub.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault()

        let offset = 0

        if (windowWidth < 768) {
            offset = 65
            mobileTrigger.click()
        }

        const elem = document.querySelector(this.getAttribute('href')).getBoundingClientRect().top + window.pageYOffset - offset

        window.scrollTo({
            top: elem,
            behavior: 'smooth'
        })

    })
})


const mobileTrigger = document.getElementById('mobile-nav-trigger')

mobileTrigger.addEventListener('click', () => {
    document.body.classList.toggle('mobile-nav-open')
})
